import type React from "react"
import { useTranslation } from "react-i18next"
import { Outlet, useParams } from "react-router"

import { AuthenticatedPageLayout } from "@/components/authenticated-page-layout"

import { SitesIndexNavigation } from "./sites-index-navigation"

export const SitesLayoutRoute: React.FC = () => {
  const { t } = useTranslation("common")
  const { siteId } = useParams()

  return (
    <AuthenticatedPageLayout
      secondary={siteId ? undefined : <SitesIndexNavigation />}
      title={t("moduleTitle.sites")}
      wrapInPage={false}
    >
      <Outlet />
    </AuthenticatedPageLayout>
  )
}
